import { Player, Team } from "./Index";
import { Model } from "./Model";

export interface Attendance extends Model {
	matchAttendance: number;
	matchAwayAttendance: number;
}

export class Attendance implements Attendance {

	constructor(data?: Partial<Attendance>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}